import axios from 'axios'
import Qs from 'qs'

// 创建一个axios实例
const service = axios.create({
  // https://h5.chuangxiangtiaodong.com/apitop/api/index
  baseURL: 'https://h5.chuangxiangtiaodong.com/apitop/api/index',
  transformRequest:[function(data){
    return Qs.stringify(data)
  }],
  timeout: 3000,
});

// 添加请求拦截器
service.interceptors.request.use(config => {
  // console.log(config)
  // 打开可能会报错 x-token不被允许
  // config.headers['token'] = 'x-xxxxxxxxxxxxxxxxxxx';
  return config;
},error => {
  // 请求错误做些事
  return Promise.reject(error);
});

// 添加相应拦截器
service.interceptors.response.use(response => {
  // console.log(response)
  const res = response.data;
  // 如果返回的状态码不是10000 就主动报错
  if(res.code != 0){
    return Promise.reject(res.message || 'error');
  }
  return res;
},error => {
  // 返回接口的错误信息
  return Promise.reject(error);
})

export default service


// WEBPACK FOOTER //
// ./src/api/request.js